<template>
  <div>
    <TopHeader code="study" />

    <section class="container-fluid uc-bg2">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link :to="{ name: 'LearningMap' }" class="item"
                >学习</router-link
              >
              <router-link to="" class="item">学习地图</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-learnMap1">
      <div class="container">
        <div class="row uc-mb40">
          <div class="col-24 col-sm-12 img-box">
            <el-image :src="model.cover">
              <div slot="error" class="image-slot">
                <img src="../../assets/images/default-hd.png" />
              </div>
            </el-image>
          </div>
          <div class="col-24 col-sm-12 chart-box">
            <!-- <img src="@/assets/images/img263.png" /> -->
            <div style="display:block;text-align:center;">
              <el-progress
                type="dashboard"
                :stroke-width="20"
                :percentage="model.progress"
                :width="337"
                :color="colors"
              ></el-progress>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-24">
            <div class="title">{{ model.name }}</div>
            <div class="info">
              <i class="uc-blue">岗位数：{{ (model.stages || []).length }}</i>
            </div>
            <div class="con">{{ model.description }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-learnMap2">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div
              class="swiper-box"
              :style="
                `height:${
                  options[model.stage_count - 1 > 0 ? model.stage_count - 1 : 0]
                    .height
                }px;overflow:hidden;`
              "
            >
              <!-- <img src="@/assets/images/img264.png" class="bgs" /> -->
              <div class="bgs">
                <div v-for="(item, index) in model.stages" :key="index">
                  <router-link
                    class="jobItem"
                    :to="{
                      name: 'LearningMapDetails',
                      params: { id: model.id },
                      query: { stageId: item.id },
                    }"
                    hover-class="none"
                    :style="`top:${item.y}px;left:${item.x}px`"
                  >
                    <div v-if="item.type == 'blue'">
                      <img
                        src="@/assets/images/icon201-bg.png"
                        class="icon-addr-bg"
                      />
                    </div>
                    <div v-if="item.type == 'orange'">
                      <img
                        src="@/assets/images/icon202-bg.png"
                        class="icon-addr-bg"
                      />
                    </div>
                    <div class="addr-box">
                      <div v-if="item.type == 'blue'">
                        <img
                          src="@/assets/images/icon201.png"
                          class="icon-addr"
                        />
                      </div>
                      <div v-if="item.type == 'orange'">
                        <img
                          src="@/assets/images/icon202.png"
                          class="icon-addr"
                        />
                      </div>
                      <div class="txt uc-blue">{{ item.progress }}%</div>
                    </div>
                    <div
                      class="tips uc-blue"
                      :class="item.position"
                      v-if="item.type == 'blue'"
                    >
                      {{ item.name }}
                    </div>
                    <div
                      class="tips uc-orange"
                      :class="item.position"
                      v-if="item.type == 'orange'"
                    >
                      {{ item.name }}
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'LearningMapPath',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      query: { id: this.$route.params.id },
      colors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#6f7ad3', percentage: 100 },
      ],
      options: [
        { x: '600', y: '20', position: 'left', height: 174 * 1 },
        { x: '550', y: '150', position: 'right', height: 174 * 2 },
        { x: '430', y: '280', position: 'right', height: 174 * 3 },
        { x: '400', y: '480', position: 'right', height: 174 * 4 },
        { x: '480', y: '630', position: 'right', height: 174 * 5 },
        { x: '580', y: '780', position: 'right', height: 174 * 6 },
        { x: '450', y: '960', position: 'right', height: 174 * 7 },
        { x: '600', y: '1080', position: 'right', height: 174 * 8 },
        { x: '430', y: '1260', position: 'right', height: 174 * 9 },
        { x: '400', y: '1520', position: 'right', height: 174 * 10 },
      ],
      model: {},
      list: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getLearningMapPath();
    },
    async getLearningMapPath() {
      const response = await this.$api.learningmap.getLearningMapPath(
        this.query
      );
      const data = response.data.data;
      for (let index = 0; index < data.stages.length; index++) {
        data.stages[index].x = this.options[index].x;
        data.stages[index].y = this.options[index].y;
        data.stages[index].position = this.options[index].position;
        data.stages[index].type =
          data.stages[index].tenant_id === data.post_id ? 'orange' : 'blue';
      }
      this.model = data;
    },
  },
};
</script>
